import React from 'react';
import PropTypes from 'prop-types';
import { Components, translate, Utils } from 'versafleet-core';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';

const {
  Helper,
} = Utils;

class ActionPanelFilterAccountButton extends React.Component {
  componentDidMount() {
    this.props.dispatch(ReduxActions.billingAccount.fetchOptionList());
  }

  render() {
    const {
      id, value, onChange, optionBillingAccounts, strings,
      className, filterClassName, children,
    } = this.props;
    const options = (optionBillingAccounts || []).map(option => ({
      value: option.id, text: option.name,
    }));

    let text;
    if (value.length <= 1) {
      text = strings.account.item;
    } else {
      text = `${value.length > 1 && value.length < options.length
        ? strings.multiple : strings.all} ${strings.account.itemPlural}`;
    }

    const subText = value.length === 1 && options.length > 0 ? (options.find(
      option => value[0] === option.value,
    ) || {}).text : undefined;

    // Filter values that are available in the account options
    const filteredValues = value.filter(accountId => options.some(
      option => option.value === accountId,
    ));

    return (
      <Components.ActionPanel.DropdownButton
        className={className}
        id={Helper.isNullOrUndefined(id) ? undefined : `${id}__dropdown-button`}
        showArrow
        subText={subText}
        text={text}
      >
        {children}
        <Components.ActionPanel.FilterTagDropdown
          className={filterClassName}
          error={strings.account.error}
          id={Helper.isNullOrUndefined(id) ? undefined : `${id}__filter-tag-dropdown`}
          onChange={v => onChange(v)}
          options={options}
          placeholder={strings.account.placeholder}
          value={filteredValues}
        />
      </Components.ActionPanel.DropdownButton>
    );
  }
}

ActionPanelFilterAccountButton.displayName = 'Action Panel Filter Account Button';

ActionPanelFilterAccountButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  filterClassName: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  optionBillingAccounts: PropTypes.arrayOf(PropTypes.shape()),
  strings: PropTypes.shape({
    account: PropTypes.shape({
      error: PropTypes.string,
      item: PropTypes.string,
      itemPlural: PropTypes.string,
      placeholder: PropTypes.string,
    }),
    multiple: PropTypes.string,
    all: PropTypes.string,
  }).isRequired,
  value: PropTypes.arrayOf(PropTypes.number),
};

ActionPanelFilterAccountButton.defaultProps = {
  className: '',
  children: null,
  filterClassName: '',
  id: '',
  onChange: null,
  optionBillingAccounts: [],
  value: [],
};

function mapStateToProps(state) {
  const { billingAccount } = state;
  return {
    optionBillingAccounts: billingAccount.optionBillingAccounts,
  };
}

export default connect(mapStateToProps)(translate('Task.filter')(ActionPanelFilterAccountButton));
